export const SignupError = {
  emailAlreadyExists: "email already exists",
};

export const LoginError = {
  invalidCredentials: "invalidate-credentials",
  emailNotVerified: "email-not-verified",
};
